export const table = {
  columns: {
    index: {
      active: !true,
    },
  },
}
